module.exports = __webpack_public_path__ + "static/media/Desiree_Cox.86548861.png";